import { ProductCardView } from '../../ProductCard/ProductCardView.ts';
import { isArray } from '@fxts/core';

/**
 * `ProductCardView[]` type guard
 */
export function isProductCardViews(items: unknown): items is ProductCardView[] {
  if (!isArray(items)) {
    return false;
  } else {
    return items.length === 0 || (items.length > 0 && items[0] instanceof ProductCardView);
  }
}
